export default __webpack_public_path__ + "static/media/prezens.0eb1c3a7.png";